type SavableAttachment = {
  file: { name: string };
  fileSize?: number | null;
  status: 'saved' | 'unsaved' | 'saving';
  tempIsShareable?: boolean;
};

/**
 * Records the id classic returned for an uploaded file and promotes the
 * attachment to saved. Every transaction type stores the same fields, so this
 * is the default behaviour of the attachments section.
 */
export const markAttachmentAsSaved = <
  TAttachment extends SavableAttachment
>(args: {
  attachment: TAttachment;
  uploadedId: string;
  fileSize: number;
}): TAttachment => {
  return {
    ...args.attachment,
    file: {
      ...args.attachment.file,
      name: args.attachment.file.name,
      id: args.uploadedId,
      isShareable: args.attachment.tempIsShareable === true,
    },
    fileSize: args.fileSize,
    status: 'saved',
  };
};
